<template>
  <div class="common-box margin-t10 application private intendant">
    <!--    公募基金推荐-->
    <div class="left">
      <p v-for="(val,index) in 3" :key="index" class="input-box">
        <el-input v-model="input" placeholder="请输入内容">
          <i slot="suffix">%</i></el-input>
        <el-input v-model="input" placeholder="请输入内容"></el-input>
      </p>
      <button class="inquire-btn">提交</button>
    </div>
    <div class="right">
      <div class="r-title">调整记录</div>
      <ul class="con-box">
        <li v-for="(val,index) in 3" :key="index +'tz'">
          <span class="index">{{index+1}}.</span>
          <span class="agent">经办人:张三</span>
          <span class="time">时间：2023年11月28日</span>
          <span class="callout">调出代码：032659</span>
          <span class="fold">调入代码：026555</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "publicPlacement",
    data(){
      return{
        input:''
      }
    }

  }
</script>

<style scoped lang="less">
  .private{
    min-height: 608px;
    display: flex;
    .left{
      width:413px;
      box-sizing: border-box;
      padding:81px 50px 0 50px;
      .input-box{
        display: flex;
        padding-bottom:10px;
        /deep/ .el-input, /deep/ .el-input .el-input__inner{
          width:152px;
          height:32px;
          outline: none;
          color:@color3;
          .el-input__suffix .el-input__suffix-inner{
            line-height: 32px;
            color:@color3;
          }
        }
        >div:first-child{
          margin-right: 10px;
        }
      }
      .inquire-btn{
        float: right;
        margin: 13px 0 0 0;
      }
    }
    .right{
      padding-right:50px;
      width:712px;
      .r-title{
        font-size: 16px;
        font-weight: bold;
        color: @color3;
        height:81px;
        padding-top:32px;
        box-sizing: border-box;
      }
      .con-box{
        border:1px solid @colorC8;
        height:171px;
        width:100%;
        border-radius: 5px;
        background-color: @wColor;
        padding:31px 0 0 18px;
        color:@color3;
        box-sizing: border-box;
        li{
          margin-bottom: 20px;
          font-size: 16px;
          font-weight: 500;
          >span{
            margin-right: 30px;
          }
          .index{
            margin-right: 10px;
          }
          >span:last-child{
            margin-right: 0;
          }
        }

      }
    }
  }

</style>
